import React, {useState, useEffect, useMemo} from 'react';
import ProtectedRoute from '../../routes/protected';
import { useParams } from 'react-router-dom';
import careerService from '../../services/data/career.service';
import SkeletonSummary from './skeletonSummary';
import CareerHeader from './careerHeader';
import CareerMenu from './careerMenu';
import CareerPerformanceList from './careerPerformanceList';
import useUserData from '../../context/user';
import useCompanyData from '../../context/company';
import UsePerms from '../../context/userAccess';


export default function CareerPerformance() {

    const [pageLoad, setPageLoad] = useState(true)
    const { id } = useParams()
    const [userEmployee, setUserEmployee] = useState('')
    const [showPerformanceTabs, setShowPerformanceTabs] = useState(false)
    const [isAnyManager, setIsAnyManager] = useState(false)
    const {user} = useUserData()
    const {rootUser} = useCompanyData()
    const VerifyPerms = UsePerms()
    
    useEffect(() => {

        getData()
        
        
    }, [])

    function getData() {

        const companyId = localStorage.getItem("companyId")

        careerService.getEmployeeSummary({ company_id: companyId }).then((me) => {
            if ((me.team && me.team.length > 0) || rootUser) setIsAnyManager(true)
        }).catch(() => {})

        careerService.getEmployeeSummary({ company_id: companyId, id }).then((response) => {    
            setUserEmployee(response)
        }).catch((error) => {
            console.log(error.response)
        }).finally(() => {
            setPageLoad(false)
        })
    
    }

    useMemo(() => {
        // if user is superior, show performance tabs
        if (userEmployee && userEmployee.manager && userEmployee.manager.uid === user.uid) {
            setShowPerformanceTabs(true)
        }
        // if its the user itself, show performance tabs
        if (userEmployee && userEmployee.user.id === user.uid) {
            setShowPerformanceTabs(true)
        }
        // if user has perms to create eprformance review, show performance tabs
        if (VerifyPerms(['add_performancereview']) || rootUser) {
            setShowPerformanceTabs(true)
        }
    }, [userEmployee, user])

    return (
        <ProtectedRoute>

            <div className="container-fluid">
                
                <CareerHeader Employee={userEmployee} />

                <div className='my-4 mx-5 py-3 rounded-top' style={{minHeight: '500px'}}>

                    <CareerMenu EmployeeId={userEmployee.id} showPerformanceTabs={showPerformanceTabs} showTransferTab={showPerformanceTabs || isAnyManager} Page='performance' />

                    <div className='bg-white py-4 rounded'>

                        {
                            pageLoad ?
                            <SkeletonSummary />
                            :
                            <>
                            <div className='row'>
                                <div className='col'>
                                    <div className='p-2 m-1'>
                                        
                                        <CareerPerformanceList userEmployee={userEmployee} />

                                    </div>
                                </div>
                            </div>
                            </>
                        }
                        
                    </div>
                </div>
            </div>

        </ProtectedRoute>
    )
}